module.exports = __webpack_public_path__ + "static/creativity-4cb3ba299e4f8f58f6755ff4f95ba6c9.png";